import { styled } from "sharedUI/styles";

export const OverviewSectionStyle = styled.div`
    margin-bottom: 20px;

    .sort-button {
        position: absolute;
        top: 0;
        right: 0;

        display: flex;
        align-items: center;
        padding: 4px 8px;
        gap: 4px;

        font-size: 13px;
        color: ${p => p.theme.textPale};
        cursor: pointer;

        :hover {
            color: ${p => p.theme.textDark};
        }
    }
`;
